import React from 'react';
import PropTypes from 'prop-types';

import './slider.scss';
import { getClass } from '../../../utils/component-helpers';

const Slider = props => {
  const { selected, onClick } = props;

  return (
    <button
      className="slider-btn"
      onClick={e => {
        e.preventDefault();
        onClick(e);
      }}
    >
      <div className={getClass('slider-toggle', { selected })}>
        <span />
      </div>
    </button>
  );
};

export default Slider;
